import React from "react";
import styles from "./Admin.module.css";
import { Outlet } from "react-router-dom";
import { TabsNav, TabNav } from "../components/TabsNav";

const Admin = () => {
  return (
    <div className={styles.wrapper}>
      <TabsNav className={styles.tabs} tabType="underline">
        <TabNav to="/admin/users">Usuarios</TabNav>
        <TabNav to="/admin/events">Eventos</TabNav>
      </TabsNav>
      <Outlet />
    </div>
  );
};

export default Admin;
